<template>
  <SnackBar
    @cancel="$emit('cancel')"
    @save="$emit('save')"
    :disabled="disabled"
    :model-value="displaySaveBar"
    :processing="processing"
    :timeout="-1"
    data-testid="save-bar"
    text="You have unsaved changes."
    cancelable
    saveable
  />
</template>

<script setup>
import SnackBar from '@/shared/components/SnackBar.vue';

defineEmits(['cancel', 'save']);

const displaySaveBar = defineModel({ type: Boolean, default: false });

defineProps({
  disabled: Boolean,
  processing: Boolean,
});
</script>
